<script>
  import estados from '~js/estados';
  import { checkbox } from 'vue-strap';
  import pessoaServico from '~modulos/acessos/servico';
  
  export default {
    components: { checkbox },
    props: {
      fornecedor: {
        type: Object,
        required: true,
      },
      carregando: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {
        estados: estados,
        desabilitarEndereco: false,
      }
    },
    methods: {
      validar(valido) {

        if (!valido) throw new Error("validacao com erro");

        return this.$validator.validateAll();
      },
      getCEP() {
        if (this.carregando) return;

        let textoCEP = this.fornecedor.cep.replace('-', '')

        if (textoCEP.length == 8) {
          this.desabilitarEndereco = true;

          pessoaServico
            .cep(textoCEP)
            .then(cepObj => {
              this.fornecedor.endereco = cepObj.logradouro.substring(0, 60);
              this.fornecedor.bairro = cepObj.bairro.substring(0, 60);
              this.fornecedor.cidade = cepObj.localidade.substring(0, 60);
              this.fornecedor.estado = cepObj.uf;
              this.fornecedor.numero = "";
              this.fornecedor.complemento = "";
              this.desabilitarEndereco = false;
            })
            .catch(error => {
              this.desabilitarEndereco = false;
            });
        }
      },
    },
    watch: {
      'fornecedor.cep': 'getCEP'
    }
  }
</script>

<template>
  <div>

    <div class="row">
      <div class="col-sm-6">
        <div class="form-group required" :class="{'has-error': errors.has('nomePessoaFisicaJuridica')}">
          <label class="control-label" for="nome-terceiro">Razão social</label>

          <input type="text"
                 class="form-control"
                 id="nome-terceiro"
                 v-model="fornecedor.nomePessoaFisicaJuridica"
                 data-vv-name="nomePessoaFisicaJuridica"
                 data-vv-as="Razão social"
                 v-validate="'required'"
                 maxlength="100">

          <p class="text-danger" v-show="errors.has('nomePessoaFisicaJuridica')">{{ errors.first('nomePessoaFisicaJuridica') }}</p>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group required" :class="{'has-error': errors.has('nomeFantasia')}">
          <label class="control-label" for="nome-fantasia">Nome fantasia</label>

          <input type="text"
                 class="form-control"
                 id="nome-fantasia"
                 v-model="fornecedor.nomeFantasia"
                 data-vv-name="nomeFantasia"
                 data-vv-as="Nome fantasia"
                 v-validate="'required'"
                 maxlength="100">

          <p class="text-danger" v-show="errors.has('nomeFantasia')">{{ errors.first('nomeFantasia') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('cep')}">
          <label class="control-label" for="cep">CEP</label>

          <input type="text"
                 class="form-control"
                 id="cep"
                 v-model="fornecedor.cep"
                 data-vv-as="cep"
                 data-vv-name="cep"
                 :disabled="desabilitarEndereco"
                 v-mascara="'cep'"
                 v-validate="'required'">

          <p class="text-danger" v-show="errors.has('cep')">{{ errors.first('cep') }}</p>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group required" :class="{'has-error': errors.has('endereco')}">
          <label class="control-label" for="endereco">Endereço</label>

          <input id="endereco"
                 class="form-control"
                 type="text"
                 v-model="fornecedor.endereco"
                 data-vv-name="endereco"
                 data-vv-as="endereço"
                 :disabled="desabilitarEndereco"
                 v-validate="'required'"
                 maxlength="100">

          <p class="text-danger" v-show="errors.has('endereco')">{{ errors.first('endereco') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('numero')}">
          <label class="control-label" for="numero">Número</label>

          <input id="numero"
                 class="form-control"
                 type="text"
                 v-model="fornecedor.numero"
                 data-vv-name="numero"
                 data-vv-as="número"
                 v-validate="'required'"
                 maxlength="10">

          <p class="text-danger" v-show="errors.has('numero')">{{ errors.first('numero') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-3">
        <div class="form-group">
          <label class="control-label" for="complemento">Complemento</label>

          <input id="complemento"
                 class="form-control"
                 type="text"
                 v-model="fornecedor.complemento"
                 maxlength="80">
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('bairro')}">
          <label class="control-label" for="bairro">Bairro</label>

          <input type="text"
                 class="form-control"
                 id="bairro"
                 v-model="fornecedor.bairro"
                 data-vv-as="bairro"
                 data-vv-name="bairro"
                 :disabled="desabilitarEndereco"
                 v-validate="'required'"
                 maxlength="80">

          <p class="text-danger" v-show="errors.has('bairro')">{{ errors.first('bairro') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('cidade')}">
          <label class="control-label" for="cidade">Cidade</label>

          <input type="text"
                 class="form-control"
                 id="cidade"
                 v-model="fornecedor.cidade"
                 data-vv-as="cidade"
                 data-vv-name="cidade"
                 :disabled="desabilitarEndereco"
                 v-validate="'required'"
                 maxlength="40">

          <p class="text-danger" v-show="errors.has('cidade')">{{ errors.first('cidade') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('estado')}">
          <label class="control-label" for="estado">Estado</label>

          <select id="estado"
                  class="form-control"
                  v-model="fornecedor.estado"
                  data-vv-as="estado"
                  data-vv-name="estado"
                  v-validate="'required'">
            <option value="">Selecione...</option>
            <option :value="estado.sigla" v-for="estado in estados">{{ estado.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('estado')">{{ errors.first('estado') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-4">
        <div class="form-group">
          <label class="control-label" for="documento">CNPJ</label>

          <input type="text"
                 class="form-control"
                 id="documento"
                 v-model="fornecedor.cpfCnpj"
                 disabled>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <label class="control-label" for="inscricao-estadual">Inscrição estadual</label>

          <input type="text"
                 class="form-control"
                 id="inscricao-estadual"
                 v-model="fornecedor.identidadeInscEstadual"
                 maxlength="20">
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <label class="control-label" for="inscricao-municipal">Inscrição municipal</label>

          <input type="text"
                 class="form-control"
                 id="inscricao-municipal"
                 v-model="fornecedor.carteiraTrabalhoInscMunicipal"
                 maxlength="20">
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <div class="checkbox">
          <checkbox class="text" v-model="fornecedor.pagamentoBoleto" value="true" type="success">
            Receber pagamentos por boleto
          </checkbox>
        </div>
      </div>
    </div>
      
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/fornecedor/componentes/compartilhado/FormDadosCadastrais.vue